import React, { useState, useEffect } from "react";
// file ke top par (baaki imports ke saath)
import { FaArrowUp } from "react-icons/fa";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaAngleRight,
  FaCheck
} from "react-icons/fa";

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer">
      {/* Top join area (same as before) */}
      <div className="footer-join">
        <div className="join-inner">
          <h2 className="join-title">Join Gojuris.in</h2>
          <p className="join-sub">Largest Encyclopaedia of Legal Database in India</p>

          <div className="join-form">
            <input
              type="text"
              className="join-input"
              placeholder="Enter your Mobile or Email."
              aria-label="contact"
            />
            <button className="btn btn-primary">Contact Us</button>
          </div>
        </div>
      </div>

      {/* Lower columns: corrected JSX */}
      <div className="footer-lower">
        <div className="footer-container">
          <div className="footer-left">
            <a href="/" className="brand-link" style={{ textDecoration: "none" }}>
              <span className="brand">KVM NOTITIA</span>
              <h2 className="brand-sub">(A Unit of Capital Law Infotech)</h2>
            </a>

            <div className="footer-contact pt-3">
              <p className="address-line">3/88, Ram Street, Vishwas Nagar, DELHI - 110032</p>

              <div style={{ fontSize: "14px", marginTop: 8 }}>
                <div style={{ marginBottom: 6, color: "rgba(255,255,255,0.88)" }}>Branches:</div>

                <ul className="branches" style={{ listStyle: "none", paddingLeft: 0 }}>
                  <li style={{ display: "flex", gap: 8, alignItems: "flex-start", marginBottom: 6 }}>
                    <FaCheck style={{ color: "#e86b55", marginTop: 2 }} />
                    <span style={{fontSize:"14px"}}>Shop No. 13-14, Civil Wing, Tis Hazari Courts, DELHI – 110054, Ph : +91 93102 26000</span>
                  </li>

                  <li style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                    <FaCheck style={{ color: "#e86b55", marginTop: 2 }} />
                    <span  style={{fontSize:"14px"}}>D-142, Lower Gr Floor, Lajpat Nagar-I, New Delhi – 110 024</span>
                  </li>
                </ul>
              </div>

              <p className="mt-3"><strong>Phone:</strong> <span className="muted">+91 76780 73260</span></p>
              <p><strong>Email:</strong> <span className="muted">contact@supersteno.com</span></p>
            </div>
          </div>

          <div className="footer-columns">
            <div className="col footer-links">
              <h3 style={{textAlign:'left'}}>Useful Links</h3>
              <ul className="link-list">
                <li><FaAngleRight className="li-icon" /> <a href="/">Home</a></li>
                <li><FaAngleRight className="li-icon" /> <a href="/about">About us</a></li>
                <li><FaAngleRight className="li-icon" /> <a href="/services">Services</a></li>
                <li><FaAngleRight className="li-icon" /> <a href="/terms">Terms of service</a></li>
              </ul>
            </div>

            <div className="col footer-links">
              <h3 style={{textAlign:'left'}}>Our Services</h3>
              <ul className="link-list">
                <li><FaAngleRight className="li-icon" /> <a href="/case-law">Case Law Search</a></li>
                <li><FaAngleRight className="li-icon" /> <a href="/central-laws">Central Laws</a></li>
                <li><FaAngleRight className="li-icon" /> <a href="/state-laws">State Laws</a></li>
                <li><FaAngleRight className="li-icon" /> <a href="/legal-news">Legal News</a></li>
              </ul>
            </div>

            <div className="col">
              <h3 style={{textAlign:'left'}}>Follow Us</h3>
              <p className="follow-text" style={{textAlign:'left'}}>Follow us on our social media channels</p>
              <div className="socials">
                <a className="social" aria-label="twitter" href="#"><FaTwitter /></a>
                <a className="social" aria-label="facebook" href="#"><FaFacebookF /></a>
                <a className="social" aria-label="instagram" href="#"><FaInstagram /></a>
                <a className="social" aria-label="linkedin" href="#"><FaLinkedinIn /></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll to top */}
      {showTop && (
        <button className="scroll-top-btn" onClick={handleTop} aria-label="scroll to top">
           <FaArrowUp />
        </button>
      )}
    </footer>
  );
}
